import React, { useEffect, useState } from "react";
import Layout from "./include/layout";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticate } from "./app/providers/authSlice";
import { myroutes } from "../routes/webroute";
import Filarial from "./include/filarial";
import { Calendar } from "primereact/calendar";
import InscriptionsService from "./inscriptions/InscriptionsService";
import ClassesService from "./classe/ClassesService";
import { Chart } from 'primereact/chart';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import fr from 'date-fns/locale/fr'; // Importez la locale française


export default function Dashboard() {
  //check if user is authenticated
  const dispatch = useDispatch();
  const [inscriptions, setInscriptions] = useState(null);
  const [classes, setClasses] = useState(null);
  const [nombreclasses, setNombreClasses] = useState(null);
  const [nombreEleves, setNombreEleves] = useState(null);
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);
  const [date, setDate] = useState(null);
  const [programme, setProgramme] = useState('');
  const [hoveredProgramme, setHoveredProgramme] = useState(null);
  const token = useSelector(state => state.auth.token)
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});
  const activeLink = "TABLEAU DE BORD";
  const montant = 10000000;
  registerLocale('fr', fr);
  //get liste inscriptions
  const fetchInscriptions = async () => {
    try {
      const res = await InscriptionsService.index(token);
      if (res && res.data && res.data.data && res.data.data.inscriptions) {
        setInscriptions(res.data.data.inscriptions);
        setNombreEleves(res.data.data.inscriptions.length);
        console.log(res.data.data.inscriptions.length)
      }
    } catch (error) {
      console.log(error);
    }
  };

//liste classes
const fetchClasses = async () => {
    try {
      const res = await ClassesService.index(token);
      if (res && res.data && res.data.data && res.data.data.classes) {
        setClasses(res.data.data.classes);
        setNombreClasses(res.data.data.classes.length);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
        const data = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July' ],
            datasets: [
                {
                    label: 'Total payés',
                    data: [65, 59, 80, 81, 56, 55, 40],
                    fill: true,
                    borderColor: documentStyle.getPropertyValue('--green-500'),
                    tension: 0.4,
                    backgroundColor: 'rgba(0, 128, 0, 0.128)'
                },
                {
                    label: 'Total impayés',
                    data: [28, 48, 40, 19, 86, 27, 90,],
                    fill: true,
                    borderColor: documentStyle.getPropertyValue('--red-500'),
                    tension: 0.4,
                    backgroundColor: 'rgba(255, 0, 0, 0.132)'

                }
            ]
        };
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary
                    },
                    grid: {
                        color: surfaceBorder
                    }
                }
            }
        };

        const handleSaveProgramme = () => {
            // Fonction d'enregistrement d'un programme
            console.log(`Date: ${date.toLocaleDateString()}, Programme: ${programme}`);
          };



  useEffect(() => {
    fetchInscriptions();
    fetchClasses();
    setChartData(data);
    setChartOptions(options);
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }
  }, [dispatch]);
  return (
    <React.Fragment>
      <Layout>
        {/* Content */}
        <div className="container-xxl flex-grow-1 container-p-y">
          <Filarial activeLink={activeLink} />
          <div className="row" style={{marginBottom:"-35px"}}>
            <div className="col-lg-8 col-md-8 col-sm-8">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-12 mb-4 mt-4">
                  <div className="card-dash2 blue2 bg-secondaryx text-whitex">
                    <div className="card-body d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <h3
                            className="card-titlex fw-bold mb-0"
                            style={{ color: "white", fontSize: "20px" }}
                          >
                            {nombreEleves}
                          </h3>
                          <span
                            className="d-block mb-1"
                            style={{ color: "white", fontSize: "14px" }}
                          >
                            Elèves
                          </span>
                        </div>
                      </div>
                      <div className="avatar flex-shrink-0">
                        <i
                          class="fa-solid fa-users"
                          style={{
                            width: "150%",
                            height: "80%",
                            color: "#00000052",
                          }}
                        ></i>{" "}
                      </div>
                    </div>
                    <div className="card-footerx text-center">
                      <Link
                        to={myroutes.inscriptions}
                        className="cardfooter btn btn-secondary mb-3"
                        style={{ fontSize: "13px" }}
                      >
                        {" "}
                        <span className="me-1">Voir la liste </span>{" "}
                        <i class="fa-solid fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 mb-4 mt-4">
                  <div className="card-dash2 yellow2 bg-secondaryx text-whitex">
                    <div className="card-body d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <h3
                            className="card-titlex fw-bold mb-0"
                            style={{ color: "white", fontSize: "20px" }}
                          >
                            60
                          </h3>
                          <span
                            className="d-block mb-1"
                            style={{ color: "white", fontSize: "14px" }}
                          >
                            Garçons
                          </span>
                        </div>
                      </div>
                      <div className="avatar flex-shrink-0">
                        <i
                          class="fa-solid fa-users"
                          style={{
                            width: "150%",
                            height: "80%",
                            color: "#00000052",
                          }}
                        ></i>{" "}
                      </div>
                    </div>
                    <div className="card-footerx text-center">
                      <button
                        className="cardfooter btn btn-secondary mb-3"
                        style={{ fontSize: "13px" }}
                      >
                        {" "}
                        <span className="me-1">Voir la liste </span>{" "}
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 mb-4 mt-4">
                  <div className="card-dash2 blue2 bg-secondaryx text-whitex">
                    <div className="card-body d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <h3
                            className="card-titlex fw-bold mb-0"
                            style={{ color: "white", fontSize: "20px" }}
                          >
                            40
                          </h3>
                          <span
                            className="d-block mb-1"
                            style={{ color: "white", fontSize: "14px" }}
                          >
                            Filles
                          </span>
                        </div>
                      </div>
                      <div className="avatar flex-shrink-0">
                        <i
                          class="fa-solid fa-users"
                          style={{
                            width: "150%",
                            height: "80%",
                            color: "#00000052",
                          }}
                        ></i>{" "}
                      </div>
                    </div>
                    <div className="card-footerx text-center">
                      <Link
                        className="cardfooter btn btn-secondary mb-3"
                        style={{ fontSize: "13px" }}
                      >
                        {" "}
                        <span className="me-1">Voir la liste </span>{" "}
                        <i class="fa-solid fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-12 mb-4 mt-4">
                  <div className="card-dash2 yellow2 bg-secondaryx text-whitex">
                    <div className="card-body d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <div>
                          <h3
                            className="card-titlex fw-bold mb-0"
                            style={{ color: "white", fontSize: "20px" }}
                          >
                           {nombreclasses}
                          </h3>
                          <span
                            className="d-block mb-1"
                            style={{ color: "white", fontSize: "14px" }}
                          >
                            Classes
                          </span>
                        </div>
                      </div>
                      <div className="avatar flex-shrink-0">
                        <i
                          class="fa-solid fa-house"
                          style={{
                            width: "150%",
                            height: "80%",
                            color: "#00000052",
                          }}
                        ></i>{" "}
                      </div>
                    </div>
                    <div className="card-footerx text-center">
                      <Link to={myroutes.classes_index}
                        className="cardfooter btn btn-secondary mb-3"
                        style={{ fontSize: "13px" }}
                      >
                        {" "}
                        <span className="me-1">Voir la liste </span>{" "}
                        <i class="fa-solid fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4 mt-1">
                  <div className="row">
                    <div className="col-md-3 col-sm-3">
                      <div className="card-dash3 yellow1 bg-secondaryx text-whitex">
                        <div className="card-body justify-content-center align-items-center">
                          <div>
                            <i
                              class="fa-solid fa-money-bill"
                              style={{
                                fontSize:"20px",
                                color: "#fff",
                              }}
                            ></i>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9 col-sm-9">
                      <div className="card-dash3 blue3 bg-secondaryx text-whitex p-2">
                        <p className="fw-bold justify-content-center pt-2">{montant.toLocaleString('fr-FR')} F CFA
 </p> 
                        <p className="mb-2" style={{fontSize:"12px", marginTop:"-10px"}}> Cumul Journalier</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4 mt-1">
                <div className="row">
                    <div className="col-md-3 col-sm-3">
                      <div className="card-dash3 yellow1 bg-secondaryx text-whitex">
                        <div className="card-body justify-content-center align-items-center">
                          <div>
                            <i
                              class="fa-solid fa-money-bill"
                              style={{
                                fontSize:"20px",
                                color: "#fff",
                              }}
                            ></i>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9 col-sm-9">
                      <div className="card-dash3 blue3 bg-secondaryx text-whitex p-2">
                        <p className="fw-bold justify-content-center pt-2">{montant.toLocaleString('fr-FR')} F CFA</p> 
                        <p className="mb-2" style={{fontSize:"12px", marginTop:"-10px"}}> Cumul mensuel</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 mb-4 mt-1">
                <div className="row">
                    <div className="col-md-3 col-sm-3">
                      <div className="card-dash3 yellow1 bg-secondaryx text-whitex">
                        <div className="card-body justify-content-center align-items-center">
                          <div>
                            <i
                              class="fa-solid fa-money-bill"
                              style={{
                                fontSize:"20px",
                                color: "#fff",
                              }}
                            ></i>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9 col-sm-9">
                      <div className="card-dash3 blue3 bg-secondaryx text-whitex p-2">
                        <p className="fw-bold justify-content-center pt-2">{montant.toLocaleString('fr-FR')} F CFA</p> 
                        <p className="mb-2" style={{fontSize:"12px", marginTop:"-10px"}}> Cumul annuel</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="mb-4" style={{ backgroundColor: 'white', padding: '10px', marginTop:"24px", minHeight:"335px", borderRadius:"5px" }}>
                <div className="row">
                <div className="flex justify-content-center">
                <p className="text-center mt-2 fw-bold">RECAPITULATIF DES PAIEMENTS IMPAYES </p>
                <table>
                    <tr>
                        <td>
                        <div className="mb-1 fw-bold"style={{ backgroundColor: '#FEBC62', padding: '8px', marginTop:"50px", Height:"100px", margin:"20px", width:"150px", color:"white" }}>
                            Scolarité
                        </div>
                        </td>
                        <td>
                           <p className="fw-bold text-black mt-4" >150 000 F CFA</p> 
                        </td>
                    </tr> 
                    <tr>
                        <td>
                        <div className="mb-1 fw-bold"style={{ backgroundColor: '#1A7EBB', padding: '8px', marginTop:"50px", Height:"100px", margin:"20px", width:"150px", color:"white" }}>
                            Frais inscriptions
                        </div>
                        </td>
                        <td>
                            <p className="fw-bold text-black mt-4">5 000 F CFA</p> 
                        </td>
                    </tr> 
                    <tr>
                        <td>
                        <div className="mb-1 fw-bold"style={{ backgroundColor: '#55BAF4', padding: '8px', marginTop:"50px", Height:"100px", margin:"20px", width:"150px", color:"white" }}>
                            Frais TD
                        </div>
                        </td>
                        <td>
                        <p className="fw-bold text-black mt-4">25 000 F CFA</p> 
                        </td>
                    </tr> 
                    <tr>
                        <td>
                        <div className="mb-1 fw-bold"style={{ backgroundColor: '#326096', padding: '8px', marginTop:"50px", Height:"100px", margin:"20px", width:"150px", color:"white" }}>
                           Cantine
                        </div>
                        </td>
                        <td>
                        <p className="fw-bold text-black mt-4">10 000 F CFA</p> 
                        </td>
                    </tr> 
                    <tr>
                        <td>
                        <div className="mb-1 fw-bold"style={{ backgroundColor: '#32376D', padding: '8px', marginTop:"50px", Height:"100px", margin:"20px", width:"150px", color:"white" }}>
                            Bulletins
                        </div>
                        </td>
                        <td>
                        <p className="fw-bold text-black mt-4">5 000 F CFA</p> 
                        </td>
                    </tr> 
                </table>

               
 
                </div>
                </div>
            </div>
            </div>
          </div>
          <div className="row">
          <div className="col-lg-8 col-md-8 col-sm-8" style={{marginTop:"-95px"}}>
          <div className="card  p-4">
            <p className="text-center fw-bold">STATISTIQUES DE VERSEMENTS DES SCOLARITES </p>
            <Chart type="line" data={chartData} options={chartOptions}   style={{ height: "380px" }}
 />
        </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
      <div className="mb-2 mt-4" style={{ backgroundColor: 'white', padding: '10px', borderRadius: "5px" }}>
        <div className="row">
          <div className="flex justify-content-center">
            <div className="text-center">
              <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: "bold", color: "#5B7BA7", padding: "5px" }}>
                Aujourd'hui : {new Date().toLocaleDateString()}
              </div>
              <DatePicker
                selected={date}
                onChange={(date) => setDate(date)}
                inline
                showWeekNumbers
                locale="fr"
              />

                {/***   <div className="mt-4 ">
                <label htmlFor="programme" className="form-label">Configurer un programme :</label>
                <input
                  id="programme"
                  className="form-control"
                  value={programme}
                  onChange={(e) => setProgramme(e.target.value)}
                  rows="4"
                />
              </div>
              <button className="btn btn-primary mt-3" onClick={handleSaveProgramme}>
                Valider             
                 </button>
                 */}
              
            </div>
          </div>
        </div>
      </div>
    </div>
        </div>
        </div>

        {/* / Content */}
      </Layout>
    </React.Fragment>
  );
}
